/**
 * Reads a duration token off :root so a timing lives in exactly one place.
 *
 * Two of these (--route-fade, --route-scene-return) are consumed by both the
 * stylesheet that animates with them and the script that has to wait for
 * that animation. Hard-coding the milliseconds in the TypeScript is how a
 * cross-fade ends up swapping the DOM 40ms before it has finished fading.
 */
export function cssDurationMs(name: string, fallback: number): number {
  const raw = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  if (raw.endsWith("ms")) {
    const ms = Number.parseFloat(raw);
    return Number.isFinite(ms) ? ms : fallback;
  }
  if (raw.endsWith("s")) {
    const seconds = Number.parseFloat(raw);
    return Number.isFinite(seconds) ? seconds * 1000 : fallback;
  }
  return fallback;
}
